import { Loader2, RefreshCw, Trash2 } from "lucide-react";
import { BackendButton } from "@/app/components/backend/backend-ui";

type UploadActionButtonsProps = {
  isUploading: boolean;
  isDeleting: boolean;
  hasImage: boolean;
  onUploadClick: () => void;
  onDeleteClick: () => void;
  disabled?: boolean;
};

/**
 * Upload action buttons component
 *
 * Provides consistent upload/replace and delete button styling
 * with loading states and proper accessibility.
 */
export function UploadActionButtons({
  isUploading,
  isDeleting,
  hasImage,
  onUploadClick,
  onDeleteClick,
  disabled = false,
}: UploadActionButtonsProps) {
  return (
    <div className="mt-3 flex flex-row gap-2">
      <BackendButton
        type="button"
        size="xs"
        variant="secondary"
        className="justify-center font-normal [&_svg]:size-3"
        onClick={onUploadClick}
        disabled={isUploading || disabled}
      >
        <div className="flex items-center justify-center gap-1">
          {isUploading ? (
            <Loader2 className="-translate-y-[0.5px] animate-spin" />
          ) : (
            <RefreshCw className="-translate-y-[0.5px]" />
          )}
          <span>{isUploading ? "Hochladen..." : "Ersetzen"}</span>
        </div>
      </BackendButton>

      {hasImage && (
        <BackendButton
          type="button"
          size="xs"
          variant="secondary"
          className="justify-center text-xs font-normal [&_svg]:size-3"
          onClick={onDeleteClick}
          disabled={isDeleting || disabled}
        >
          <>
            {isDeleting ? (
              <Loader2 className="-translate-y-[0.5px] animate-spin" />
            ) : (
              <Trash2 className="-translate-y-[0.5px]" />
            )}
            <span>{isDeleting ? "Löschen..." : "Löschen"}</span>
          </>
        </BackendButton>
      )}
    </div>
  );
}
